import { CopyButton, SwitchAppButton } from "../../../../../components";
import { IViewBankTransferBeneficiary } from "../../../../../interfaces-and-types";
import { truncateStringWithEllipsis } from "../../../../../utils";

interface IBeneficiaryListItemProps {
  beneficiary: IViewBankTransferBeneficiary;
  selectBeneficiary: (ben: IViewBankTransferBeneficiary) => void;
}

export const BeneficiaryListItem = ({
  beneficiary,
  selectBeneficiary,
}: IBeneficiaryListItemProps) => (
  <div className="cds--structured-list-row" key={beneficiary.id}>
    <div className="cds--structured-list-td" title={beneficiary.id}>
      <div className="flex-container justify-content--start align-items--center no-wrap">
        <div className="transaction-id-text modal-header--title">
          <span title={beneficiary.id}>
            {truncateStringWithEllipsis(beneficiary.id, 5)}
          </span>
        </div>
        <div className="copy-button--container ml-3">
          <CopyButton
            name="copy-beneficiary-id-button"
            stringToCopy={beneficiary.id}
            iconDescription="copy beneficiary id"
            className="copy-btn"
          />
        </div>
      </div>
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-teal">
      {beneficiary.full_name?.trim() || <>(No&nbsp;Alias)</>}
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-primary">
      {beneficiary.account_name}
    </div>

    <div className="cds--structured-list-td font-ctm--semibold text-primary">
      {beneficiary.account_number}
    </div>

    <div className="cds--structured-list-td font-ctm--semibold ">
      {beneficiary.bank_name}
    </div>

    <div
      className="cds--structured-list-td"
      title="Select this beneficiary as recipient"
    >
      <SwitchAppButton
        // kind="danger"
        kind="secondary"
        onClick={() => selectBeneficiary(beneficiary)}
        size="sm"
        className="flex-box"
      >
        Select
      </SwitchAppButton>
    </div>
  </div>
);
